import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loadAudienceTracker } from './utils/audience';

loadAudienceTracker(process.env.REACT_APP_UMAMI_WEBSITE_ID);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
